import React from 'react'
import Link from '../Link/index'

export interface SidebarLogoProps {
  /** Optional override for the wordmark size; defaults are set in SCSS. */
  width?: number
  height?: number
}

/**
 * Clickable AI Guide wordmark for the AI Chat sidebar (AI-818).
 *
 * Rendered as text rather than the OracleCommons `GuideLogo` SVG so that
 * the appearance can adapt to light/dark mode via CSS variables. In light
 * mode the wordmark is filled with the brand gradient via `background-clip:
 * text`; in dark mode it falls back to a plain near-white color (per Figma).
 *
 * The `width`/`height` props are retained for callers that want to override
 * sizing inline but are not currently consumed — sizing is driven by
 * font-size in `_OracleSidebar.scss`.
 */
export const SidebarLogo: React.FC<SidebarLogoProps> = () => (
  <Link
    to="/aichat/conversation"
    data-testid="sidebar-logo-link"
    className="sidebar-logo"
  >
    <span className="sidebar-logo__wordmark" data-testid="sidebar-logo-wordmark">
      AI Guide
      <sup className="sidebar-logo__beta">Beta</sup>
    </span>
  </Link>
)
